import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import { Link } from "react-router-dom"
import HashLink from "components/HashLink"

import logo from "images/saits-logo.png"
import whiteLogo from "images/saits-logo-white.png"
import BurgerMenu from "./BurgerMenu"
import HoverLink from "components/HoverLink"

const LINKS = [
  { name: "Startsida", path: "/#home" },
  { name: "Kontakta oss", path: "/#contact" },
  { name: "Case studies", path: "/case-studies" },
  { name: "Jobba hos oss", path: "/#work" },
]

const MenuBar = ({ variant }) => (
  <nav
    className={cx(styles.container, {
      [styles.whiteVariant]: variant === "white",
    })}
  >
    <div className={styles.wrapper}>
      <div className={styles.imageContainer}>
        <Link to="/">
          <img
            className={styles.logo}
            src={variant === "white" ? whiteLogo : logo}
            alt="SAITS logo"
          />
        </Link>
      </div>

      <div>
        <div className={styles.links}>
          {LINKS.map(link => (
            <HoverLink key={cx(link.name)} className={styles.link}>
              <HashLink to={link.path} text={link.name} />
            </HoverLink>
          ))}
        </div>
        <BurgerMenu links={LINKS} variant={variant} />
      </div>
    </div>
  </nav>
)

export default MenuBar



// WEBPACK FOOTER //
// ./src/components/MenuBar/index.jsx